import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import SegmentButton from './SegmentButton';

const SCROLL_OFFSET = 190;
const MEDIA = '(min-width: 48em)';

const View = styled.section`
    overflow: hidden;
    position: relative;

    &::after {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0px;
        left: 0;
        background-image: linear-gradient(
            to right,
            transparent 0%,
            #979797 40%,
            #979797 60%,
            transparent
        );
    }
`;

const ScrollPane = styled.div`
    display: flex;
    align-items: flex-start;
    transform: translateX(-${props => props.translateBy}px);
    transition: transform 0.2s ease-out;
`;

const StyledSegmentButton = styled(SegmentButton)`
    min-width: ${SCROLL_OFFSET}px;
    padding: 0 24px 24px;
    flex: 1;
    border-radius: 0;
    border-bottom: 4px solid transparent;
    position: relative;
    z-index: 1;

    ${props => {
        if (props.active) {
            return css`
                border-bottom-color: #4a4a4a;
            `;
        }
    }};
`;

const ScrollBtn = styled.button`
    width: 22px;
    height: 100%;
    padding: 0;
    border: none;
    border-radius: 0;
    position: absolute;
    top: 0;
    ${props => props.position}: 0;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.8);
    cursor: pointer;

    @media ${MEDIA} {
        width: 50px;
    }

    ${props => {
        if (props.position === 'right') {
            return css`
                box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.2);
            `;
        }

        return css`
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        `;
    }} &:focus {
        outline: none;
    }

    svg {
        fill: #4a4a4a;
    }
`;

class SegmentMenu extends Component {
    state = {
        scrolledBy: 0,
        showRightScrollBtn: false,
        showLeftScrollBtn: false,
    };

    componentDidMount() {
        this.checkOverflow();

        window.addEventListener('resize', this.checkOverflow);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkOverflow);
    }

    checkOverflow = () => {
        const { offsetWidth, scrollWidth } = this.scrollPaneRef;
        const { scrolledBy } = this.state;

        const offset = SCROLL_OFFSET * scrolledBy + 80;

        this.setState({
            showRightScrollBtn: scrollWidth - offset > offsetWidth,
            showLeftScrollBtn: scrolledBy > 0,
        });
    };

    render() {
        const {
            scrolledBy,
            showRightScrollBtn,
            showLeftScrollBtn,
        } = this.state;

        const { selectedIndex, onClickItem } = this.props;

        return (
            <View innerRef={comp => (this.viewRef = comp)}>
                {showLeftScrollBtn && (
                    <ScrollBtn onClick={this.handleScrollRight} position="left">
                        <svg
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                        </svg>
                    </ScrollBtn>
                )}

                <ScrollPane
                    innerRef={comp => (this.scrollPaneRef = comp)}
                    translateBy={scrolledBy * SCROLL_OFFSET}
                >
                    {this.props.children.map((child, i) => {
                        return (
                            <StyledSegmentButton
                                key={child.props.title}
                                {...child.props}
                                active={i === selectedIndex}
                                onClick={e => onClickItem(i, e)}
                            />
                        );
                    })}
                </ScrollPane>

                {showRightScrollBtn && (
                    <ScrollBtn onClick={this.handleScrollLeft} position="right">
                        <svg
                            fill="#000000"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                        </svg>
                    </ScrollBtn>
                )}
            </View>
        );
    }

    handleScrollLeft = () => {
        this.setState(
            {
                scrolledBy: this.state.scrolledBy + 1,
            },
            () => {
                this.checkOverflow();
            }
        );
    };

    handleScrollRight = () => {
        this.setState(
            {
                scrolledBy: this.state.scrolledBy - 1,
            },
            () => {
                this.checkOverflow();
            }
        );
    };
}

SegmentMenu.defaultProps = {
    onClickItem: () => {},
};

SegmentMenu.propTypes = {
    selectedIndex: PropTypes.number,
    onClickItem: PropTypes.func,
};

export default SegmentMenu;



// WEBPACK FOOTER //
// ./src/components/shared/SegmentMenu.js